import Layout from '@/layout'

const AirExportRouter = {
  path: '/AirExport',
  component: Layout,
  redirect: 'noredirect',
  name: 'AirExport',
  meta: {
    title: 'airExport',
    icon: 'daohang-ziliaoguanli',
    roles: []
  },
  children: [
    {
      path: 'AeBooking',
      component: () => import('@/views/cargo/v0/AirExport/aeBooking'),
      name: 'AeBooking',
      meta: { title: 'airExportBooking' },
      roles: ['module_AEBooking']
    },
    {
      path: 'AeBookingVerify',
      component: () => import('@/views/cargo/v0/AirExport/aeBookingVerify'),
      name: 'AeBookingVerify',
      meta: { title: '订单预审' },
      roles: ['module_AEPreVerify']
    },
    {
      path: 'AeRouteCentral',
      component: () => import('@/views/cargo/v0/AirExport/aeRouteCentral'),
      name: 'AeRouteCentral',
      meta: { title: '航线中心' },
      roles: ['module_AERouteCentral']
    },
    {
      path: 'RouteBooking',
      component: () => import('@/views/cargo/v0/AirExport/routeBooking'),
      name: 'RouteBooking',
      meta: { title: '航线订舱' },
      roles: ['module_RouteBooking']
    },
    {
      path: 'CharterAndPalletStatistics',
      component: () => import('@/views/cargo/v0/AirExport/charterAndPalletStatistics/index'),
      name: 'CharterAndPalletStatistics',
      meta: { title: '包机包板统计' },
      roles: ['module_CharterAndPalletStatistics']
    },
    {
      path: 'StayWarehousing',
      component: () => import('@/views/cargo/v0/AirExport/stayWarehousing'),
      name: 'StayWarehousing',
      meta: { title: '待入库清单' },
      roles: ['module_StayWarehousing']
    },
    {
      path: 'AePrepareDocument',
      component: () => import('@/views/cargo/v0/AirExport/aePrepareDocument'),
      name: 'AePrepareDocument',
      meta: { title: '制单列表' },
      roles: ['module_AEPrepareDocument']
    },
    {
      path: 'AeMawb',
      component: () => import('@/views/cargo/v0/AirExport/aeMawb'),
      name: 'AeMawb',
      meta: { title: '主单管理' },
      roles: ['module_AEMAWB_AEBooking']
    },
    {
      path: 'BatchUploadImage',
      component: () => import('@/views/cargo/v0/AirExport/batchUploadImage'),
      name: 'BatchUploadImage',
      meta: { title: '上传图片' },
      roles: ['module_BatchUploadImage']
    },
    {
      path: 'FmAirConfig',
      component: () => import('@/views/cargo/v0/AirExport/fmAirConfig'),
      name: 'FmAirConfig',
      meta: { title: '空运维护' },
      roles: ['module_FMAirConfig']
    },
    {
      path: 'AirlineProduct',
      component: () => import('@/views/cargo/v0/AirExport/airlineProduct'),
      name: 'AirlineProduct',
      meta: { title: '航线产品' },
      roles: ['module_AirlineProduct']
    },
    {
      path: 'LoadManagement',
      component: () => import('@/views/cargo/v0/AirExport/loadManagement'),
      name: 'LoadManagement',
      meta: { title: '配载管理' },
      roles: ['module_LoadManagement']
    },
    {
      path: 'CabinAllowanceQuery',
      component: () => import('@/views/cargo/v0/AirExport/cabinAllowanceQuery'),
      name: 'CabinAllowanceQuery',
      meta: { title: '舱位余量查询' },
      roles: ['module_CabinAllowanceQuery']
    },
    {
      path: 'AECustomsInventory',
      component: () => import('@/views/cargo/v0/AirExport/aeCustomsInventory'),
      name: 'AECustomsInventory',
      meta: { title: '报关清单' },
      roles: ['module_AECustomsInventory']
    },
    {
      path: 'IATAPrice',
      component: () => import('@/views/cargo/v0/AirExport/iataPrice'),
      name: 'IATAPrice',
      meta: { title: 'IATA运价' },
      roles: ['module_IATAPrice']
    },
    {
      path: 'StayUploadPhotoList',
      component: () => import('@/views/cargo/v0/AirExport/stayUploadPhotoList'),
      name: 'StayUploadPhotoList',
      meta: { title: '待拍照清单' },
      roles: ['module_StayUploadPhotoList']
    },
    {
      path: 'CarFormAE',
      component: () => import('@/views/cargo/v0/AirExport/carFormAE'),
      name: 'CarFormAE',
      meta: { title: '车单' },
      roles: ['module_CarFormAE']
    },
    {
      path: 'Warehousing',
      component: () => import('@/views/cargo/v0/AirExport/Warehousing/index'),
      name: 'Warehousing',
      meta: { title: '仓储' },
      roles: ['module_Warehousing']
    },
    {
      path: 'FrontEndWarehousing',
      component: () => import('@/views/cargo/v0/AirExport/FrontEndWarehousing/index'),
      name: 'FrontEndWarehousing',
      meta: { title: '前置仓收货' },
      roles: ['module_FrontEndWarehousing']
    },
    {
      path: 'CargoTerminalDelivery',
      component: () => import('@/views/cargo/v0/AirExport/cargoTerminalDelivery'),
      name: 'CargoTerminalDelivery',
      meta: { title: '货站交货' },
      roles: ['module_CargoTerminalDelivery']
    },
    {
      path: 'RouteProductRevenueStatistics',
      component: () => import('@/views/cargo/v0/AirExport/routeProductRevenueStatistics'),
      name: 'RouteProductRevenueStatistics',
      meta: { title: '航线产品收益统计' },
      roles: ['module_RouteProductRevenueStatistics']
    },
    {
      path: 'PreWarehouseOutbound',
      component: () => import('@/views/cargo/v0/AirExport/PreWarehouseOutbound/index'),
      name: 'PreWarehouseOutbound',
      meta: { title: '前置仓出库' },
      roles: ['module_PreWarehouseOutbound']
    },
    {
      path: 'AEBatchUploadFile',
      component: () => import('@/views/cargo/v0/AirExport/uploadFile/index'),
      name: 'AEBatchUploadFile',
      meta: { title: '上传文件' },
      roles: ['module_BatchUploadFile']
    },
    {
      path: 'ImportCharge',
      component: () => import('@/views/cargo/v0/AirExport/ImportCharge/index'),
      name: 'ImportCharge',
      meta: { title: '批量导入费用(空出)' },
      roles: ['module_fmImportChargeAE']
    },
    {
      path: 'OperationTrack',
      component: () => import('@/views/cargo/v0/AirExport/OperationTrack/index'),
      name: 'OperationTrack',
      meta: { title: '操作要求跟踪' },
      roles: ['module_FMOperationTrack']
    }
  ]
}

export default AirExportRouter
